import {ArticlesPageMeta} from '@/src/features/news-articles/meta'

export {ArticlesPageMeta}
